const renewalDate = new Intl.DateTimeFormat("es-AR", {
  day: "numeric",
  month: "long",
  year: "numeric",
  timeZone: "America/Argentina/Mendoza",
});

const paymentDate = new Intl.DateTimeFormat("es-AR", {
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
  timeZone: "America/Argentina/Mendoza",
});

const paymentStatusLabels = Object.freeze({
  created: "Pendiente",
  pending: "Pendiente",
  approved: "Aprobado",
  failed: "Rechazado",
  canceled: "Cancelado",
  refunded: "Reembolsado",
  charged_back: "Contracargo",
});

const HOUR_MS = 60 * 60 * 1_000;
const DAY_MS = 24 * HOUR_MS;

export function formatRenewalSummary(value, now = new Date()) {
  if (!value) return "";
  const date = new Date(value);
  const current = now instanceof Date ? now : new Date(now);
  if (Number.isNaN(date.getTime()) || Number.isNaN(current.getTime())) return "";

  const difference = date.getTime() - current.getTime();
  const formattedDate = renewalDate.format(date);
  if (difference <= 0) {
    return `Próxima acreditación: ${formattedDate} · pendiente de confirmación`;
  }
  if (difference < HOUR_MS) {
    return `Próxima acreditación: ${formattedDate} · falta menos de una hora`;
  }
  if (difference < DAY_MS) {
    const hours = Math.ceil(difference / HOUR_MS);
    return `Próxima acreditación: ${formattedDate} · ${hours === 1 ? "falta 1 hora" : `faltan ${hours} horas`}`;
  }
  const days = Math.ceil(difference / DAY_MS);
  return `Próxima acreditación: ${formattedDate} · ${days === 1 ? "falta 1 día" : `faltan ${days} días`}`;
}

export function formatBillingPaymentDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return paymentDate.format(date);
}

export function billingPaymentStatusLabel(status) {
  return paymentStatusLabels[status] || "Estado desconocido";
}
